/*
* -----------------------------------------------------------------------------
* POPUP TOGGLE
* -----------------------------------------------------------------------------
* @version 0.0.1.custom
* @kind component
* @overview Transitionable dialog state toggling.
* @copyright 2021 Cam Gould & Creiamo Pty Ltd (FKA Elkfox) - All rights reserved
* -----------------------------------------------------------------------------
*/

if (customElements.get("popup-toggle") === undefined) {
    class PopupToggle extends HTMLElement {
        constructor() {
            super();
            this.close = this.close.bind(this);
            this.keyEvents = this.keyEvents.bind(this);
            this.clickEvents = this.clickEvents.bind(this);
            this.transitions = false;
            this.addEventListener("transitionstart", this.transitioning);
            // START site specific customization
            this.section = this.closest('.shopify-section');
            this.sectionPopupClass = 'popup-active';
            // END site specific customization
        }
        toggle(setfocus = true) {
            if (this.hasAttribute("hidden")) this.open(setfocus);
            else if (this.transitions) this.addEventListener("transitionend", this.close);
            else this.close();
        }
        open(setfocus) {
            // START site specific customization
            this.section.classList.add(this.sectionPopupClass);
            // END site specific customization
            this.removeAttribute("hidden");
            this.querySelectorAll("[tabindex]").forEach((item)=>item.setAttribute("tabindex", 0));
            document.documentElement.classList.add("dialog-open");
            document.addEventListener("keyup", this.keyEvents);
            this.removeEventListener("transitionstart", this.transitioning);
            this.addEventListener("click", this.clickEvents);
            this.addEventListener("focusout", this.trapFocus);
            if (!setfocus) return;
            this.addEventListener("transitionend", this.setFocus);
        }
        close() {
            // START site specific customization
            this.section.classList.remove(this.sectionPopupClass);
            // END site specific customization
            this.setAttribute("hidden", "");
            this.querySelectorAll("[tabindex]").forEach((item)=>item.setAttribute("tabindex", -1));
            document.documentElement.classList.remove("dialog-open");
            document.removeEventListener("keyup", this.keyEvents);
            this.removeEventListener("click", this.clickEvents);
            this.removeEventListener("focusout", this.trapFocus);
            this.removeEventListener("transitionend", this.close);
        }
        setFocus() {
            this.querySelectorAll("[tabindex]")[0]?.focus();
            this.removeEventListener("transitionend", this.setFocus);
        }
        trapFocus() {
            if (this.contains(event.relatedTarget)) return;
            this.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')[0].focus();
        }
        keyEvents(event1) {
            if (event1.code === "Escape") this.close();
        }
        clickEvents() {
            if (event.target.closest('[name="close"]') || !this.firstElementChild.contains(event.target)) this.close();
        }
        transitioning() {
            this.transitions = true;
        }
    }
    customElements.define("popup-toggle", PopupToggle);
}